import { queryKeys } from '../queryKeys';

import { fetchLogo } from './queryFunctions';

export type CreateLogoQueryOptionsArgs = {
  collectionId: number;
  kSql?: string;
  referenceId: string;
};

export function createLogoQueryOptions({ collectionId, kSql, referenceId }: CreateLogoQueryOptionsArgs) {
  return {
    queryKey: queryKeys.logo(referenceId),
    queryFn: () =>
      fetchLogo({
        collectionId,
        kSql,
      }),
  };
}
